import React, { useEffect, useMemo, useState } from "react";
import { useOpticsStore } from "../../../stores/use-optics-store";
import { usePages } from "../usePages";
import { useAtlassianLocale } from "@Shared/Hooks/useAtlassianLocale";
import CustomEmptyState from "../../../components/empty-state/CustomEmptyState";
import { CUSTOM_EMPTY_STATE_KEY } from "../../../components/empty-state/custom-templates";
import PagesPreview from "../preview/PagesPreview";
import { PaginationTypes } from "@Shared/Pagination-Types";
import { usePagesStore } from "../../../stores/use-page-store";

function ManualPages({ isEdit, mode }) {
  const [locale] = useAtlassianLocale();
  const isCosmosInstalled = useOpticsStore((state) => state.isCosmosInstalled);

  const { config, selectedTab } = usePagesStore((state) => ({
    config: state.data.config,
    selectedTab: state.getSelectedTab(),
  }));

  const { tabs, pagination } = config || {};

  const limit = isEdit ? 999 : Number(tabs?.[selectedTab]?.limit || 4);
  const manuallyPicked = tabs?.[selectedTab]?.manuallyPicked || [];

  const pageQueries = usePages(manuallyPicked, locale, isCosmosInstalled);

  const pageResults = useMemo(
    () =>
      pageQueries
        .map((q) => q.data)
        .filter((q) => q && !q.isPlaceholder && !q.isNew),
    [pageQueries]
  );

  const [page, setPage] = useState(0);
  const isCarousel = pagination === PaginationTypes.CAROUSEL;
  const startIndex = isCarousel ? page * limit : 0;
  const endIndex = page * limit + limit;
  const paginatedPages = pageResults.slice(startIndex, endIndex);

  const queryPagination = {
    disabled: isEdit || pagination === PaginationTypes.NONE,
    hasNextPage: endIndex < pageResults.length,
    hasPrevPage: page > 0,
    onNext: () => {
      if (endIndex < pageResults.length) setPage((prev) => prev + 1);
    },
    onPrev: () => {
      if (page > 0) setPage((prev) => prev - 1);
    },
    page,
    setPage,
  };

  useEffect(() => setPage(0), [pagination]);

  if (!paginatedPages.length) {
    return <CustomEmptyState templateKey={CUSTOM_EMPTY_STATE_KEY.NEWS_SETUP} />;
  }

  const paginationData = { [isCarousel ? page : 0]: paginatedPages };

  return (
    <PagesPreview
      data={paginationData}
      queryPagination={queryPagination}
      mode={mode}
    />
  );
}

export default ManualPages;
